export default "__VITE_ASSET__Pt59qks___"